// import OButton from "components/reusable/OButton";
import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import BiddingFees from './bidding_fees/BiddingFees'
import Subscription from './subscription/Subscription'
import AuthContext from 'context/AuthContext'

const tabBtnClass =
  'ml-3 inline-block py-3 px-2 text-md xl:text-sm font-semibold border-b-2'
const tabActiveClass = 'border-lime-500 text-lime-500'
const tabBorderNoneClass = 'border-transparent'
const TAB_BIDDING_FEES = 'bidding_fees'
const TAB_SUBSCRIPTION = 'subscription'
const ReportManager = () => {
  const { t } = useTranslation()
  const { config} = useContext(AuthContext)
  const [defaultTab, setDefaultTab] = useState('bidding_fees')
  const handleTabClick = (action, e) => {
    setDefaultTab(action)
  }
  return (
    <div>
      <div className='pb-3'>
        <ul className='border-b flex'>
          <li className='mr-0'>
            <button
              onClick={handleTabClick.bind(this, TAB_BIDDING_FEES)}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]: defaultTab === TAB_BIDDING_FEES,
                [tabBorderNoneClass]: defaultTab !== TAB_BIDDING_FEES
              })}
            >
              {t('O_BIDDING_FEES')}
            </button>
          </li>
          <li className='mx-0'>
            <button
              onClick={handleTabClick.bind(this, TAB_SUBSCRIPTION)}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]: defaultTab === TAB_SUBSCRIPTION,
                [tabBorderNoneClass]: defaultTab !== TAB_SUBSCRIPTION
              })}
            >
              {t('O_SUBSCRIPTION')}
            </button>
          </li>
        </ul>
      </div>

      {defaultTab === TAB_BIDDING_FEES
        ? (
          <BiddingFees config={config} />)
        : defaultTab === TAB_SUBSCRIPTION
          ? (<Subscription config={config} />)
          : null}
    </div>
  )
}

export default ReportManager
